export const PDF_GENERATE = 'PDF_GENERATE';
export const PDF_GENERATE_INIT = 'PDF_GENERATE_INIT';
